module.exports = __webpack_public_path__ + "img/langdao.8ceb872d.png";